/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import UserToken from 'ui/components/user/UserToken.vue';

/**
 * This component is the user tokens management page.
 *
 * @category ui.pages.user
 * @exports APITokens
 * @component
 */
const __vue_script__ = {
    name: 'APITokens',

    props: {
        testing: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            tokens: [],
            integrations: {},
            refreshTokens: [],
            error: null
        };
    },

    created() {
        this.init();
    },

    methods: {
        /**
         * Initializes the component
         */
        async init() {
            try {
                const data = await this.$services.oidc.getTokens();

                this.integrations = data.integrations;
                this.refreshTokens = data.refreshTokens;
                this.tokens = data.accessTokens;

            } catch (error) {
                this.error = error.message;
            }
        },

        /**
         * Opens the token's creation form
         */
        create() {
            this.$modal.show(UserToken,
                {},
                {
                    classes: 'small',
                    height: 'auto',
                    reset: true,
                    clickToClose: false
                },
                {
                    closed: () => this.init()
                }
            );
        },

        /**
         * Prompts for token removal
         *
         * @param {Object} token the token to remove
         */
        promptRemoval(token) {
            this.$modal.show('dialog', {
                title: this.$i18n.t('general.warning'),
                text: this.$i18n.t('profile.tokens.listing.revoke_prompt'),
                buttons: [
                    {
                        title: this.$i18n.t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$i18n.t('profile.tokens.listing.revoke'),
                        handler: () => { this.remove(token); this.$modal.hide('dialog'); },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Removes the specified token
         *
         * @param {Object} token the token to remove
         */
        async remove(token) {
            try {
                await this.$services.oidc.revokeToken(token.token);
                await this.init();
            } catch (error) {

                this.$notify({
                    group: 'flashes',
                    text: error.message,
                    type: 'error'
                });
            }
        },

        /**
         * Formats the unix timestamp to a human readable string
         *
         * @param {number} timestamp the timestamp to convert
         *
         * @returns {string} the formatted time
         */
        tsToFormat(timestamp) {
            const date = new Date(timestamp * 1000);
            const options = {
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            };

            return Intl.DateTimeFormat(this.$i18n.locale, options).format(date);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-tokens" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("profile.tokens.title")))]),
      _c("p", { staticClass: "intro" }, [
        _vm._v(_vm._s(_vm.$t("profile.tokens.intro"))),
      ]),
      _vm.tokens.length
        ? _c("div", { staticClass: "table-wrapper" }, [
            _c("table", { staticClass: "table-striped" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("profile.tokens.listing.app"))),
                  ]),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("profile.tokens.listing.label"))),
                  ]),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("profile.tokens.listing.created"))),
                  ]),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("profile.tokens.listing.expiration"))),
                  ]),
                  _c("th"),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.tokens, function (token) {
                  return _c("tr", { key: token.token }, [
                    _c(
                      "td",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.right",
                            value: {
                              content:
                                _vm.integrations[token.clientId].client_name,
                              delay: { show: 0, hide: 50 },
                            },
                            expression:
                              "{content: integrations[token.clientId].client_name, delay: {show: 0, hide: 50}}",
                            modifiers: { right: true },
                          },
                        ],
                        staticClass: "logo",
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value: _vm.integrations[token.clientId].logo_uri,
                              expression:
                                "integrations[token.clientId].logo_uri",
                            },
                          ],
                          key: token.clientId,
                          attrs: {
                            alt: _vm.integrations[token.clientId].client_name,
                          },
                        }),
                      ]
                    ),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          token.label ||
                            _vm.$t("profile.tokens.listing.external")
                        )
                      ),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.tsToFormat(token.iat, "YYYY-MM-DD HH:mm"))
                      ),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.tsToFormat(token.exp, "YYYY-MM-DD HH:mm"))
                      ),
                    ]),
                    _c("td", { staticClass: "actions" }, [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.left",
                              value: _vm.$t("profile.tokens.listing.revoke"),
                              expression: "$t('profile.tokens.listing.revoke')",
                              modifiers: { left: true },
                            },
                          ],
                          staticClass: "btn btn-danger btn-icon single",
                          on: {
                            click: function ($event) {
                              return _vm.promptRemoval(token)
                            },
                          },
                        },
                        [_c("i", { staticClass: "ic-trash" })]
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm.error
        ? _c("div", { staticClass: "alert alert-error" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _c("secondary-toolbar", [
        _c(
          "button",
          { staticClass: "btn btn-primary", on: { click: _vm.create } },
          [_vm._v(_vm._s(_vm.$t("profile.tokens.actions.create")))]
        ),
      ]),
      _vm.testing ? _c("v-dialog") : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/user/APITokens.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__